"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ActiveSessionFoundPopup = void 0;
const react_1 = __importStar(require("react"));
const prop_types_1 = __importDefault(require("prop-types"));
const react_design_system_1 = require("@hdh-core/react-design-system");
const react_intl_1 = require("react-intl");
const ActiveSessionFoundPopup = (_a) => {
    var props = __rest(_a, []);
    const { activeSessionDialog, date, getGlobalState, setGlobalState } = props;
    const [isOpen, setOpen] = (0, react_1.useState)(true);
    const [idleSessionDate, setIdleSessionDate] = (0, react_1.useState)(0); //NOSONAR
    const [nextlogout, setNextlogout] = (0, react_1.useState)(0); //NOSONAR
    const intl = (0, react_intl_1.useIntl)();
    (0, react_1.useEffect)(() => {
        const LoginContext = JSON.parse(window.sessionStorage.getItem('LoginContext') || '{}');
        setOpen(activeSessionDialog);
        const idleSessionTimeoutGracePeriod = LoginContext['Idle Session Timeout Grace Period'];
        const sessionTimeOut = LoginContext['Session Time Out'];
        const idleDate = (sessionTimeOut - idleSessionTimeoutGracePeriod) / 60 / 1000;
        const idleLogout = (sessionTimeOut - idleDate * 60 * 1000) / 60 / 1000;
        setIdleSessionDate(idleDate);
        setNextlogout(idleLogout);
    }, [date]);
    const msg = intl.formatMessage({ id: 'active-session-message' });
    return (react_1.default.createElement("div", null,
        react_1.default.createElement(react_design_system_1.AlertDialog, { isOpen: isOpen, setOpen: setOpen, iconType: 'reject', title: intl.formatMessage({ id: 'active-session-title' }), message: msg, onClick: () => setGlobalState(Object.assign(Object.assign({}, getGlobalState()), { sessionData: Object.assign(Object.assign({}, getGlobalState().sessionData), { isActiveSession: false }) })) })));
};
exports.ActiveSessionFoundPopup = ActiveSessionFoundPopup;
exports.ActiveSessionFoundPopup.propTypes = {
    sessionTimeoutDialog: prop_types_1.default.bool
};
exports.ActiveSessionFoundPopup.defaultProps = {
    sessionTimeoutDialog: false
};
exports.default = exports.ActiveSessionFoundPopup;
